import React from "react";

import { Routes, Route } from "react-router-dom";
import Navbar from "./Components/NavComp/navbar";
import Footer from "./Components/FooterComp/footer";
import Body from "./Components/BodyComp/body";
import WhatsAppButton from "./Components/Whatsapp/WhatsAppButton";
import ContactUs from "./Components/ContactComp/contactus";
import AboutUs from "./Components/AboutComp/aboutus";
import Treatments from "./Components/TreatmentComp/treatments";
import Gallery from "./Components/GalleryComp/gallery";
import DoctorsProfiles from "./Components/DoctorComp/doctors-profiles";
import Booking from "./Components/BookingComp/booking";

import ScrollToTop from './ScrollComp/ScrollToTop';

function App() {
  return (
    <>

      <Navbar />
    <ScrollToTop />

    
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/doctors-PROFILES" element={< DoctorsProfiles />} />
        <Route path="/treatments" element={<Treatments />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/booking" element={< Booking />} />
      </Routes>
      <Footer />

      <WhatsAppButton />
    </>
  );
}

export default App;

